import refrash2 from '../../assets/images/refresh-2.png';
export default function RefrashButton({handleSwap}) {
    return(
        <>
        <div onClick={() => handleSwap()} className="MiddleButton flex justify-center items-center cursor-pointer rounded-lg bg-gradient-to-r from-gray-500 via-gray-700 to-gray-500 shadow border-solid border-2 border-gray-800" >
            {/* <img className="h-auto max-w-full" alt='' width={24} src={refrash2} /> */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.99945 12C1.99945 6.47996 6.43945 1.99996 11.9995 1.99996C18.6695 1.99996 21.9995 7.55996 21.9995 7.55996M21.9995 7.55996V2.55996M21.9995 7.55996H17.5595" stroke="#C4FE48" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path opacity="0.6" d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        </div>
        </>

    );
}